import { render } from "./AsideEDP.vue?vue&type=template&id=94cd37da&ts=true"
import script from "./AsideEDP.vue?vue&type=script&lang=ts"
export * from "./AsideEDP.vue?vue&type=script&lang=ts"

import "./AsideEDP.vue?vue&type=style&index=0&id=94cd37da&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__